/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import { object, bool, string, func } from 'prop-types';
import {
    Dialog, DialogContent, Button, Grid, CircularProgress,
} from '@material-ui/core';

//Helpers
import { isEmpty } from '../../../../../../utils/object';
import { RecipientBookContext } from '../../Context/RecipientBookContext';
import TextFieldHelper from '../../Helpers/TextFieldHelper';
import Divider from '../../../../../../common/Divider';
import Loading from '../../../../../../common/Loading';
import { useQasAddressConfirmationDialogStyles } from '../../../../../../style/commonStyles';


const QasAddressConfirmationDialog = ({
    methods, isShowingConfirmationDialog, handleSelectAnAddress, classes, apiError,
}) => {
    const {
        isVerificationNeeded, setIsVerificationNeeded, confirmAddress, searchResults, setConfirmAddress, setKeepAddressClicked, setIsLoadingConfirmation, isLoadingConfirmation, 
    } = useContext(RecipientBookContext);
    if (!confirmAddress) return null;
    const QasAddressConfirmationDialogStyles = useQasAddressConfirmationDialogStyles();
    const recipientAddress = {
        addressLineOne: methods?.getValues('addressLineOne'),
        addressLineTwo: methods?.getValues('addressLineTwo'),
        city: methods?.getValues('city'),
        state: methods?.getValues('state'),
        zip: methods?.getValues('zip'),
        country: methods?.getValues('country'),
    };

    const address = <div style={{fontSize: '16px'}} className="margin-top-2x margin-bottom-2x"><div>{recipientAddress.addressLineOne} {recipientAddress.addressLineTwo}</div><div>{recipientAddress.city}, {recipientAddress.state} {recipientAddress.zip}</div><div>{recipientAddress.country}</div></div>;
    const suggestedList = [];
    if (!isEmpty(searchResults)) {
        searchResults.forEach((item) => {
            suggestedList.push(item.suggestion);
        });
    }
    let textInfo = isEmpty(suggestedList) ? (<p style={{fontSize: '16px'}} className="bold margin-top">We could not find a match to the address:</p>) : '';
    textInfo = !isVerificationNeeded ? (<p className="bold margin-top">You have selected address:</p>) : textInfo;
    let textOptions = isEmpty(suggestedList) ? (<p style={{fontSize: '16px'}} className="bold">Please choose one of the options below to proceed</p>) : '';
    textOptions = isVerificationNeeded ? textOptions : '';
    const suggestedSelectAddress = methods.watch('suggestedAddress');

    const handleEditAddressClicked = () => {
        setConfirmAddress(false);
        setIsVerificationNeeded(true);
    };

    const handleKeepAddressClicked = () => {
        setIsLoadingConfirmation(true);
        setIsVerificationNeeded(false);
        setKeepAddressClicked(true);
    };

    const handleChooseSeletedAddress = (searchResultsData) => {
        const indexOfSelectedAddress = searchResultsData.findIndex((result) => result.suggestion === suggestedSelectAddress);
        if (!isEmpty(searchResultsData) && searchResultsData[indexOfSelectedAddress].format) {
            const address = searchResultsData[indexOfSelectedAddress];
            handleSelectAnAddress(address);
            handleEditAddressClicked();
        }
    };

    return (
        <Dialog open={isShowingConfirmationDialog} fullWidth className={classes.main}>
            <DialogContent className={QasAddressConfirmationDialogStyles.confirmationDialogWrapper}>
                {isLoadingConfirmation
                    ? <Loading />
                    : (<Grid container direction="column" spacing={2}>
                            <Grid item xs={12}>
                                <h2 className="margin-top-2x margin-bottom-2x">Address Verification</h2>
                                {textInfo}
                                {!isEmpty(suggestedList) ? (
                                    <>
                                        <p className="margin-bottom-2x">According to the USPS&reg; the street number you entered is either missing or incorrect. Please refer to the list of options below.</p>
                                        <p className="h2">Choose Recommended Address Below:</p>
                                        <div className="align-center">
                                            <TextFieldHelper fieldName="suggestedAddress" optionsList={suggestedList} fieldLabel="Suggested Address" required={false} methods={methods} />
                                            <div className="margin-bottom-2x">
                                                <Button
                                                    variant='contained'
                                                    color="primary"
                                                    className="quaternary text-transform-none"
                                                    style={{ height: '56px', margin: '0px' }}
                                                    fullWidth
                                                    disabled={!suggestedSelectAddress}
                                                    onClick={() => handleChooseSeletedAddress(searchResults)}
                                                >
                                                    Choose Address
                                                </Button>
                                                {apiError ? apiError : ''}
                                            </div>
                                        </div>
                                        <Divider text="or" />
                                        <p className="bold margin-top h2">Keep or edit original address:</p>
                                    </>
                                ) : ''}
                                {address}
                                {textOptions}
                                <div className="align-center">
                                    <Button
                                        variant='contained'
                                        color="primary"
                                        className="quaternary text-transform-none"
                                        style={{ height: '56px', marginBottom: '10px'}}
                                        fullWidth
                                        onClick={handleEditAddressClicked}
                                    >
                                        {!isVerificationNeeded ? <CircularProgress size={20}/> : 'Edit Address'}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        fullWidth
                                        className="quaternary text-transform-none"
                                        style={{ height: '56px' }}
                                        onClick={handleKeepAddressClicked}
                                    >
                                        Keep Address
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>)
                }
            </DialogContent>
        </Dialog>
    );
}

QasAddressConfirmationDialog.propTypes = {
    methods: object.isRequired,
    classes: object.isRequired,
    apiError: string.isRequired,
    handleSelectAnAddress: func.isRequired,
    isShowingConfirmationDialog: bool.isRequired,
};

export default QasAddressConfirmationDialog;
